import { useCallback, useEffect } from 'react';
import { getLayouts, useSelectLayoutList } from 'layout/store/layoutsListSlice';
import { useDispatch } from 'store/hooks';

export function useLayoutsList(origin: string) {
    const layouts = useSelectLayoutList(origin);
    const dispatch = useDispatch();

    const forceLayoutListReload = useCallback(() => {
        if (origin) {
            dispatch(getLayouts({ origin, forceReload: true }));
        }
    }, [dispatch, origin]);

    useEffect(() => {
        if (origin) {
            dispatch(getLayouts({ origin, forceReload: false }));
        }
    }, [dispatch, origin]);

    return { layoutList: layouts, forceLayoutListReload };
}
